export default {
  "redemptionCodeRecord.title": "Redemption Code Records",
  "redemptionCodeRecord.column.no": "#NO",
  "redemptionCodeRecord.column.userNo": "UserNo",
  "redemptionCodeRecord.column.redemptionCode": "Redemption Code",
  "redemptionCodeRecord.column.channel": "Channel",
  "redemptionCodeRecord.column.amount": "Amount",
  "redemptionCodeRecord.column.withdrawLimit": "Withdraw Limit",
  "redemptionCodeRecord.column.createTime": "Create Time",
  "redemptionCodeRecord.search.userNo": "UserNo",
  "redemptionCodeRecord.search.redemptionCode": "Redemption Code",
  "redemptionCodeRecord.search.channel": "Channel",
  "redemptionCodeRecord.tooltip.copy.userNo": "Copy UserNo: {text}",
  "redemptionCodeRecord.tooltip.copy.redemptionCode": "Copy Redemption Code: {text}",
  "redemptionCodeRecord.tooltip.showUserDetails": "Show User Details",
  "redemptionCodeRecord.copy.success": "Copied to clipboard",
};